<div class="container text-center">
  <div class="row">
    <div class="col-sm-12">
      <img src="assets/img/itsme-logo.png" style="width:100%; max-width: 125px">
      <h1>{{'ITSME.LOADING' | translate}}</h1>
    </div>
  </div>
</div>
